/**
 *
 * Subscriptions
 *
 */
import React, { memo } from 'react';
import { ChartUsers } from './components/chart-users';
import { ChartOrders } from './components/chart-orders';
import { ChartDownloads } from './components/chart-download';
import { ChartTransactions } from './components/chart-transactions';
import { AnalyticsProvider } from './analytics-context';
import { AnalyticsFilterBar } from './components/analytics-filter-bar';
import { AnalyticsSummary } from './components/analytics-summary';
import ChartPaymentMethods from './components/chart-payment-methods';
import ChartCurrencyBreakdown from './components/chart-currency-breakdown';
interface Props {}

export const DashboardAnalytics = memo((props: Props) => {
  return (
    <AnalyticsProvider>
      <div className="space-y-6">
        <AnalyticsFilterBar />
        <AnalyticsSummary />
        <div className="grid gap-6 xl:grid-cols-2">
          <ChartUsers />
          <ChartOrders />
        </div>
        <div className="grid gap-6">
          <ChartDownloads />
          <ChartTransactions />
        </div>
        <div className="grid gap-6 xl:grid-cols-2">
          <ChartPaymentMethods />
          <ChartCurrencyBreakdown />
        </div>
      </div>
    </AnalyticsProvider>
  );
});
